import React from "react";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import { set } from "lodash";

import { ImportantDates } from "./ImportantDates";
import { OverallSummary } from "./OverallSummary";
import { IndicatedValueSummary2, tableDataValues } from "./IndicatedValueSummary";
import { AttachmentsSheet } from "./AttachmentsSheet";

interface IAppealsSummaryProps {
    year: string;
    isEditing: boolean;
    data: any;
    handleUpdateData: any;
    updateData: any;
}

export const AppealsSummary: React.FC<IAppealsSummaryProps> = ({
    year,
    isEditing,
    data,
    handleUpdateData,
    updateData,
}) => {
    const handleInputChange = (field: string, value: any) => {
        set(data, field, value);
        handleUpdateData(data);
    };
    const [open, setOpen] = React.useState(false);
    const onClickOpen = () => setOpen(true);
    const onClickClose = () => setOpen(false);
    const [attachmentYear, setAttachmentYear] = React.useState("");

    return (
        <>
            <Text type="h400">{`${year} Summary`}</Text>
            <Row width="100%">
                <IndicatedValueSummary2
                    tableData={tableDataValues}
                    data={data}
                    isEditing={isEditing}
                    handleInputChange={handleInputChange}
                />
                <ImportantDates
                    data={data}
                    isEditing={isEditing}
                    handleInputChange={handleInputChange}
                />
            </Row>
            <br />
            <br />
            <Row>
                <OverallSummary
                    data={data}
                    isEditing={isEditing}
                    handleUpdateData={handleUpdateData}
                    year={year}
                    onClickOpen={onClickOpen}
                    setAttachmentYear={setAttachmentYear}
                />
                <AttachmentsSheet
                    data={data}
                    open={open}
                    onClose={onClickClose}
                    handleInputChange={handleInputChange}
                    attachmentYear={attachmentYear}
                    allowUpload={isEditing && year.toString() === attachmentYear.toString()}
                    year={year}
                    updateData={updateData}
                />
            </Row>
        </>
    );
};
